import { getEnv } from "@trumpf/ux.utils";
import { i18nProvider } from "@trumpf/ux.i18n";
const getTrumpfBaseUrl = () => (getEnv() === "qa" ? "https://www-q.trumpf.com/" : "https://www.trumpf.com/");
const getShopUrl = () => (getEnv() === "qa" ? "https://www.shop-preprod.trumpf.com/" : "https://www.shop.trumpf.com/");
export const getAppLauncherTrumpf = () => {
    const { t } = i18nProvider;
    return [
        {
            icon: "uic:mytrumpf-shop",
            label: t("app.header.shopLabel"),
            slug: "trumpf-apps-shop",
            href: getShopUrl(),
            target: "_blank"
        },
        {
            icon: "uic:service-app",
            label: t("app.header.serviceAppLabel"),
            slug: "trumpf-apps-service-app",
            href: `${getTrumpfBaseUrl()}?id=4236`,
            target: "_blank"
        },
        {
            icon: "uic:smart-factory",
            label: t("app.header.smartFactorySuiteLabel"),
            slug: "trumpf-apps-smart-factory-suite",
            href: `${getTrumpfBaseUrl()}?id=6916`,
            target: "_blank"
        }
    ];
};
export const getLegalMenuItems = () => {
    const { t } = i18nProvider;
    return [
        {
            label: t("app.header.legalNoticeLabel"),
            slug: "trumpf-meta-legal-notice",
            href: `${getTrumpfBaseUrl()}?id=767`,
            target: "_blank"
        },
        {
            label: t("app.header.privacyPolicyLabel"),
            slug: "trumpf-meta-privacy-policy",
            href: `${getTrumpfBaseUrl()}?id=4244`,
            target: "_blank"
        },
        {
            label: t("app.header.copyrightLabel"),
            slug: "trumpf-meta-copyright",
            href: `${getTrumpfBaseUrl()}?id=769`,
            target: "_blank"
        }
    ];
};
//# sourceMappingURL=utils.js.map
